import { createContext, useContext } from 'react';
import mapboxgl from 'mapbox-gl';

const MapContext = createContext<mapboxgl.Map | null>(null);

export const MapProvider = MapContext.Provider;

export const useMap = (): mapboxgl.Map | null => {
  return useContext(MapContext);
};

export default MapContext;
